import { Divider } from '@chakra-ui/react'
export default Divider